import { useState, useContext } from "react";
import { Avatar } from "@mui/material";
import ContadorBadge from "shared/components/badges/ContadorBadge";
import { FaCaretDown, FaBell, FaBars, FaSearch } from "react-icons/fa";
import condominioDefaut from "static/cloud21/header/condominio-default.png";
import UserMenu from "./UserMenu";
import { Col, Row } from "react-bootstrap";
import { UserContext } from "context/UserContext";
import { MesCompetencia } from "shared/components/date/MesCompetencia";
import SeletorCondominioContexto from "./SeletorCondominioContexto";
import NotificacaoMenu from "./NotificacaoMenu";
import UnidadeSelectModal from "./UnidadeSelectModal";
import usePostAlterarCondominioContextoToken from "hooks/condominio/usePostAlterarCondominioContextoToken";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import {
  BlocoSelectDTO,
  CondominioSelectDTO,
  UnidadeSelecaoOpcaoDTO,
} from "types/dto/unidade/UnidadeSelectDTO";
import { TipoCategoriaNotificacao } from "types/dto/NotificacaoSirensDTO";
import { RequestSumarioNotificacao } from "types/request/RequestSumarioNotificacao";
import { useGetSumarioNotificacao } from "hooks/header/useGetSumarioNotificacao";
import showAlert from "shared/util/functions/alert/showAlert";
import {
  BANNER_TYPE_PRE_RELEASE_V1,
  BASE_BUCKET_AWS,
  DIA_BANNER_RELEASE_V1,
  MES_BANNER_RELEASE_V1,
  SHOW_BANNER_RELEASE_V1,
  URL_BANNER_RELEASE_V1,
} from "shared/util/perfis/exportEnvs";
import Banner from "./Banner";

interface HeaderProps {
  isSideBarAberto: boolean;
  setIsSideBarAberto: Function;
}

const Header: React.FC<HeaderProps> = (props) => {
  const {
    usuarioLogado,
    competenciaSelecionada,
    alterarCompetencia,
    condominioContexto,
    openCloseModalSelecionarCondominioContexto,
  } = useContext(UserContext);
  const [showMenuNotificacao, setShowMenuNotificacao] = useState(false);
  const [isUserMenuAberto, setIsUserMenuAberto] = useState<null | HTMLElement>(null);
  const [showBuscarUnidadesModal, setShowBuscarUnidadesModal] = useState(false);
  const [selectedCondominio, setSelectedCondominio] = useState<CondominioSelectDTO>({});
  const [selectedBloco, setSelectedBloco] = useState<BlocoSelectDTO>({});
  const [selectedUnidade, setSelectedUnidade] = useState<UnidadeSelecaoOpcaoDTO>({});

  const { redirectToV1 } = IntegracaoV1();
  const { alterarCondominioContextoToken } = usePostAlterarCondominioContextoToken();

  const inicialDate = localStorage.getItem("mesCompetencia")?.split("/");
  let mes: number = inicialDate ? parseInt(inicialDate[1]) - 1 : new Date().getMonth();
  let ano: number = inicialDate ? parseInt(inicialDate[2]) : new Date().getFullYear();
  const mesCompetenciaAtual = new Date(ano, mes, 1);
  const [selectedDate, setSelectedDate] = useState<Date | null>(mesCompetenciaAtual);
  const params = {
    codigoSuporte: usuarioLogado.codigoSuporte,
    uuidEmpresa: condominioContexto.uuid,
    uuidUsuario: usuarioLogado.uuid,
    categorias: [
      TipoCategoriaNotificacao.INFORMATIVO,
      TipoCategoriaNotificacao.PENDENCIA,
      TipoCategoriaNotificacao.ERRO,
    ].join(","),
  } as RequestSumarioNotificacao;

  const { data } = useGetSumarioNotificacao(params);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setIsUserMenuAberto(event.currentTarget);
  };

  const openBuscarUnidadesModal = () => {
    setSelectedCondominio({});
    setSelectedBloco({});
    setSelectedUnidade({});
    setShowBuscarUnidadesModal(true);
  };

  const closeBuscarUnidadesModal = () => {
    setShowBuscarUnidadesModal(false);
    setSelectedCondominio({});
    setSelectedBloco({});
    setSelectedUnidade({});
  };

  const handleCondominioSelectChange = (value: CondominioSelectDTO | null) => {
    setSelectedCondominio(value || {});
    setSelectedBloco({});
    setSelectedUnidade({});
  };

  const handleBlocoSelectChange = (value: BlocoSelectDTO | null) => {
    setSelectedBloco(value || {});
    setSelectedUnidade({});
  };

  const handleUnidadeSelectChange = (value: UnidadeSelecaoOpcaoDTO | null) => {
    setSelectedUnidade(value || {});
  };

  const handleFooterLinkClick = async () => {
    if (!selectedUnidade?.id) {
      return;
    }

    // A opção do combo traz condominioId: buscando sem condomínio selecionado, o antigo
    // selectedUnidade.condominio?.id era sempre undefined e o "Ver unidade" não fazia nada.
    const condominioId = selectedCondominio.id || selectedUnidade.condominioId;
    if (!condominioId) {
      return;
    }

    const redirectOptions = { unidadeIdEditar: Number(selectedUnidade.id) };
    const redirectPath = "/unidade/cadastrar";

    closeBuscarUnidadesModal();

    if (condominioContexto.id != null && Number(condominioContexto.id) === Number(condominioId)) {
      redirectToV1(redirectPath, redirectOptions);
      return;
    }

    await alterarCondominioContextoToken(Number(condominioId), redirectPath, redirectOptions);
  };

  const renderBuscarUnidades = () => {
    return (
      <div className="header-buscar-unidades" onClick={openBuscarUnidadesModal}>
        <FaSearch className="header-buscar-unidades-icon" />
        Buscar por unidades
      </div>
    );
  };

  const renderBotaoSideBar = () => {
    return (
      <Col xs={1}>
        <div>
          <button className={"botao-sidebar"} onClick={() => props.setIsSideBarAberto(!props.isSideBarAberto)}>
            <FaBars />
          </button>
        </div>
      </Col>
    );
  };

  const renderSeletorCompetencia = () => {
    return (
      <div>
        <div className="pt-1">
          <MesCompetencia
            usarValidacaoParaFormulario={false}
            defaultValue={competenciaSelecionada}
            value={selectedDate ?? competenciaSelecionada}
            onChange={(data: Date | null) => {
              setSelectedDate(data ? data : selectedDate);
              showAlert({
                titulo: "Atenção",
                texto: "Tem certeza que deseja alterar a competência padrão do sistema?",
                tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
                icon: "warning",
                onConfirm: () => alterarCompetencia(data ? data : mesCompetenciaAtual),
                onCancel: () => setSelectedDate(null),
              });
            }}
            variant="standard"
            style={{ width: "120px" }}
            disabledTextField
          />
        </div>
      </div>
    );
  };

  const renderCondominioContexto = () => {
    let logoBase64;
    let nome = "-";

    if (usuarioLogado.isContextoAdministradora) {
      nome = usuarioLogado.clienteGroup;
    } else {
      nome = condominioContexto.nomeCondominio || "-";
      if (condominioContexto.uuidLogo) {
        logoBase64 = BASE_BUCKET_AWS + condominioContexto.uuidLogo;
      }
    }

    return (
      <div className={"selecionar-condominio"} onClick={() => openCloseModalSelecionarCondominioContexto()}>
        <div className={"header-usuario"}>
          <img
            className="client-avatar"
            src={logoBase64 || condominioDefaut}
            alt=""
            style={{ height: 30, width: 30 }}
          />
          <div className="header-label">{nome}</div>
          <FaCaretDown />
        </div>
      </div>
    );
  };

  const renderUsuarioDropDown = () => {
    return (
      <div className={"header-usuario-dropdown "}>
        <div className={"header-usuario"} onClick={handleClick}>
          <Avatar src="/broken-image.jpg" sx={{ width: 30, height: 30 }} />
          <div className="header-label">{usuarioLogado.nome}</div>
          <FaCaretDown />
        </div>
        <UserMenu isUserMenuAberto={isUserMenuAberto} setIsUserMenuAberto={setIsUserMenuAberto} />
      </div>
    );
  };
  const renderNotificacoes = () => {
    return (
      <div onClick={() => setShowMenuNotificacao(!showMenuNotificacao)}>
        <ContadorBadge contador={data?.totalNaoLidas}>
          <FaBell size={20} />
        </ContadorBadge>

        <NotificacaoMenu
          showMenu={showMenuNotificacao}
          totalNaoLidas={data?.totalNaoLidas}
          totaisNaoLidasCategoria={new Map(Object.entries(data?.totaisNaoLidasCategoria ?? {}))}
          ultimasNotificacoesCategoria={new Map(Object.entries(data?.ultimasNotificacoesCategoria ?? {}))}
        />
      </div>
    );
  };

  return (
    <>
      {SHOW_BANNER_RELEASE_V1 === "true" && (
        <Banner
          bannerTypePreRelease={BANNER_TYPE_PRE_RELEASE_V1}
          diaBanner={DIA_BANNER_RELEASE_V1}
          mesBanner={MES_BANNER_RELEASE_V1}
          bannerURL={URL_BANNER_RELEASE_V1}
        />
      )}

      <Row className="navbar navbar-static-top gray-bg">
        {renderBotaoSideBar()}
        <Col className="header-group-itens">
          {renderBuscarUnidades()}
          {renderSeletorCompetencia()}
          {renderCondominioContexto()}
          {renderUsuarioDropDown()}
          {renderNotificacoes()}
        </Col>
        <SeletorCondominioContexto />
        <UnidadeSelectModal
          show={showBuscarUnidadesModal}
          onHide={closeBuscarUnidadesModal}
          selectedCondominio={selectedCondominio}
          onCondominioChange={handleCondominioSelectChange}
          selectedBloco={selectedBloco}
          onBlocoChange={handleBlocoSelectChange}
          selectedUnidade={selectedUnidade}
          onUnidadeChange={handleUnidadeSelectChange}
          onFooterLinkClick={handleFooterLinkClick}
        />
      </Row>
    </>
  );
};

export default Header;
